import React from 'react'
import { BigSale } from 'src/core/models'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import { customerCurrencyLabels, projectCurrencyLabels } from './sale-project-details.helpers'
import SaleProjectDetailsLabels from './SaleProjectDetailsLabels/SaleProjectDetailsLabels'
import { Divider } from 'antd'

const SaleProjectDetails: React.FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()

  return <>
    {/* Project Currency */}
    <CustomTitle label={t('Transactions.ProjectDetails')} type={null} />
    <SaleProjectDetailsLabels labels={projectCurrencyLabels(t, sale)} />

    {/* Customer Currency */}
    <Divider />
    <CustomTitle label={t('Transactions.ProjectCurrency')} type={null} />
    <SaleProjectDetailsLabels labels={customerCurrencyLabels(t, sale)} />
  </>
}

export default SaleProjectDetails
